import React from "react";
import { Col, Typography, Grid, Image } from "antd";
import {
  FacebookFilled,
  InstagramFilled,
  YoutubeFilled,
} from "@ant-design/icons";
import {
  StyledFooterContent,
  StyledFooterRow,
  StyledMenuButton,
  StyledSocialLink,
  StyledCopyrightRow,
  StyledFooterLink,
  StyledDescriptionText,
} from "./styles";
const { useBreakpoint } = Grid;

const { Title } = Typography;

const Footer = () => {
  const screens = useBreakpoint();

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <StyledFooterRow>
        <StyledFooterContent id="Contact" gutter={[8, 8]} justify="center">
          <Col
            span={22}
            sm={10}
            lg={5}
            style={{ textAlign: screens.xs ? "center" : "start" }}
          >
            <Title style={{ color: "white", fontFamily: "Inter" }} level={4}>
              Mera Peshawar
            </Title>
            <StyledDescriptionText>
              Mera Peshawar is a digital news platform covering Peshawar and
              Khyber Pakhtunkhwa, delivering timely updates, local stories, and
              regional developments that matter.
            </StyledDescriptionText>
          </Col>
          <Col
            span={22}
            sm={10}
            lg={5}
            style={{ textAlign: screens.xs ? "center" : "start" }}
          >
            <Title
              style={{
                color: "white",
                fontFamily: "Inter",
              }}
              level={4}
            >
              Menu
            </Title>
            <StyledMenuButton
              type="link"
              onClick={() => scrollToElement("Main")}
            >
              Home
            </StyledMenuButton>
            <StyledMenuButton
              type="link"
              onClick={() => scrollToElement("featureRow")}
            >
              Feature
            </StyledMenuButton>
            <StyledMenuButton
              type="link"
              onClick={() => scrollToElement("FAQS")}
            >
              FAQS
            </StyledMenuButton>
          </Col>
          <Col
            span={22}
            sm={10}
            lg={5}
            style={{ textAlign: screens.xs ? "center" : "start" }}
          >
            <Title style={{ color: "white", fontFamily: "Inter" }} level={4}>
              Visit us at
            </Title>
            <div>
              <StyledSocialLink
                href="https://www.facebook.com/profile.php?id=61587399930168"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookFilled />
                <span>Facebook</span>
              </StyledSocialLink>
              <StyledSocialLink
                href="https://www.instagram.com/mera.peshawar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramFilled />
                <span>Instagram</span>
              </StyledSocialLink>
              <StyledSocialLink
                href="https://www.youtube.com/@mera.peshawar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeFilled />
                <span>YouTube</span>
              </StyledSocialLink>
            </div>
          </Col>
          <Col
            span={22}
            sm={10}
            lg={5}
            style={{ textAlign: screens.xs ? "center" : "start" }}
          >
            <Title style={{ color: "white", fontFamily: "Inter" }} level={4}>
              A Product of
            </Title>
            <Image
              src="smartlogo.png"
              preview={false}
              alt="Logo"
              style={{
                height: "5rem",
                width: "auto",
                marginLeft: screens.xs ? "0px" : "10px",
              }}
            />
          </Col>
        </StyledFooterContent>

        <StyledCopyrightRow gutter={[8, 8]}>
          <Col
            span={22}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Copyright © 2024 Smart Forum. All rights reserved
          </Col>
          <Col
            span={22}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <StyledFooterLink
              style={{
                marginRight: screens.xs ? "5px" : "10px",
                marginLeft: screens.xs ? "5px" : "10px",
              }}
              href="/privacy-policy"
            >
              Privacy Policy
            </StyledFooterLink>
            <StyledFooterLink
              style={{ marginRight: screens.xs ? "5px" : "10px" }}
              href="/terms-of-service"
            >
              Terms Of Service
            </StyledFooterLink>
            <StyledFooterLink href="/refund-policy">
              Refund Policy
            </StyledFooterLink>
          </Col>
        </StyledCopyrightRow>
      </StyledFooterRow>
    </>
  );
};

export default Footer;
